var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"view page"},[_c(_vm.component,{key:_vm.$route.fullPath,tag:"component",staticClass:"view--sub"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }